import { createContext } from "react";

export enum ThemeContextValues {
  Cd = "cd",
  Agent = "agent",
  Performer = "performer",
  Filmmakers = "filmmakers",
  Default = "default",
}

const ThemeContext = createContext<string>("");

export default ThemeContext;
